import { ref } from 'vue'

export function usePagination (initialNum: number, initialActive: number) {
  const blockEntries = ref(3)

  function numBlockEntries (): number {
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    return viewportWidth < 480 ? 3 : viewportWidth < 600 ? 5 : 7
  }

  function createPaginationItems (num: number, active: number, entries: number = 3): number[] {
    const seoCenterPage = Math.floor(num / 2)

    const renderList: number[] = []
    let blockStart = (active - ((entries - 1) / 2)) > 0 ? (active - ((entries - 1) / 2)) : 1
    let blockEnd = blockStart + entries - 1

    if (blockEnd > num) {
      blockEnd = num
      blockStart = (blockEnd - entries + 1) > 0 ? blockEnd - entries + 1 : 1
    }

    if (blockStart > 1) renderList.push(1)

    for (let i = blockStart; i <= blockEnd; i++) {
      renderList.push(i)
    }

    if (active === 1 && seoCenterPage > (blockEnd + 1)) {
      renderList.push(seoCenterPage)
    }

    if (blockEnd < num) renderList.push(num)
    return renderList
  }

  const paginationItems = ref<number[]>(createPaginationItems(initialNum, initialActive))

  function setBlockEntriesBasedOnViewport (num: number, active: number): void {
    const entries = numBlockEntries()
    if (entries === 3) return
    blockEntries.value = entries
    paginationItems.value = createPaginationItems(num, active, entries)
  }

  function addItemStyleClass (current: number, active: number, num: number): string {
    let setStyle = 'bx-pager__item'
    const entries = blockEntries.value
    const blockStart = (active - ((entries - 1) / 2)) > 0 ? (active - ((entries - 1) / 2)) : 1
    const blockEnd = blockStart + entries - 1
    const seoCenterPage = Math.floor(num / 2)

    if (current === active) setStyle += ' bx-pager__item--active'

    if (num > entries) {
      if (current === 1 && blockStart > 2) setStyle += ' bx-pager__item--dots-after'
      if (current === blockStart && blockStart > 2) setStyle += ' bx-pager__item--dots-before'
      if (current === seoCenterPage && active === 1 && (seoCenterPage > (blockEnd + 1))) setStyle += ' bx-pager__item--dots-before'
      if (current === num && blockEnd < (num - 1)) setStyle += ' bx-pager__item--dots-before'
    }

    return setStyle
  }

  function encodeSearchAfterQueryParam (from: number, pages: number[]): string {
    // url-friendly, for the backend to decode
    return btoa(JSON.stringify({ from, pages }))
  }

  return {
    paginationItems,
    setBlockEntriesBasedOnViewport,
    addItemStyleClass,
    encodeSearchAfterQueryParam
  }
}
